import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeTestPage } from './ThemeTestPage';

// Function to inject theme test overlay
export const showThemeTest = () => {
  // Remove existing test overlay if it exists
  const existing = document.getElementById('theme-test-overlay');
  if (existing) {
    existing.remove();
  }

  // Create overlay container
  const overlay = document.createElement('div');
  overlay.id = 'theme-test-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    overflow-y: auto;
  `;

  // Create close button
  const closeButton = document.createElement('button');
  closeButton.innerHTML = '✕';
  closeButton.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10000;
    background: #ff8270;
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 20px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
  `;
  closeButton.onclick = () => overlay.remove();

  // Create content container
  const content = document.createElement('div');
  content.style.cssText = `
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  `;

  overlay.appendChild(closeButton);
  overlay.appendChild(content);
  document.body.appendChild(overlay);

  // Render React component
  const root = ReactDOM.createRoot(content);
  root.render(<ThemeTestPage />);
};

// Function to toggle dark theme
export const toggleDarkTheme = () => {
  const currentTheme =
    document.documentElement.getAttribute('data-theme') || 'tbitLight';
  const newTheme = currentTheme === 'tbitDark' ? 'tbitLight' : 'tbitDark';

  document.documentElement.setAttribute('data-theme', newTheme);
  document.documentElement.classList.remove('tbitLight', 'tbitDark');
  document.documentElement.classList.add(newTheme);
  localStorage.setItem('theme', newTheme);

  console.log(`Theme switched to: ${newTheme}`);
};

// Make functions globally available
declare global {
  interface Window {
    showThemeTest: () => void;
    toggleDarkTheme: () => void;
  }
}

// Auto-attach to window in development
if (typeof window !== 'undefined') {
  window.showThemeTest = showThemeTest;
  window.toggleDarkTheme = toggleDarkTheme;
}
